export default {"src":"/_next/static/image/public/images/ic_chat_footer.3693e3abac14507a4c4cfd47b110e958.svg","height":18,"width":19};